import React from 'react';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Text } from 'apps/auth/components/common/Text/Text';

import { MarkedListItemContainer } from './styles';

interface MarkedListItemProps {
    text?: React.ReactNode;
}

export const MarkedListItem: React.FC<MarkedListItemProps> = ({ text }) => {
    return (
        <MarkedListItemContainer>
            <Icon name="check" color="primary" rightIndent="24px" />
            <Text>{text}</Text>
        </MarkedListItemContainer>
    );
};
